import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'EMAIL_TEMPLATE' });



// WEBPACK FOOTER //
// ./src/frontend/modules/email/template/handlers.js